import { Button, Col, Form, Input, InputNumber, Row, Select, Space } from "antd";
import CustomIcon from "components/shared/CustomIcon";
import addreses from "config/api/addresses";
import patterns from "config/patterns";
import util from "config/utils";
import useApi from "hooks/useApi";
import { WageSide } from "models/paymentLink";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import LinkForShare from "./LinkForShare";

const WithFactor = () => {
    const [link, setLink] = useState<string>("")
    const [name, setName] = useState<string>("")
    const [sum, setSum] = useState<number>(0);
    const [frm] = Form.useForm();
    const { t } = useTranslation();
    const [pay, creating] = useApi({
        onSuccess: (l) => {
            setLink(l as string);
            frm.resetFields();
            setSum(0);
        }
    })
    const onConfirm = (data: any) => {
        setName(data.payerName)
        pay.post(addreses.createComplexPaymentLink, {
            ...data,
            amount: sum,
            payerMobileNumber: data.payerMobileNumber,
            extraData: JSON.stringify(data.extraData)
        })
    }
    const calcTotalAmount = (idx: number) => {
        const extraData = frm.getFieldValue("extraData");
        const relatedAmount = extraData?.[idx].amount ?? 0;
        const relatedCount = extraData?.[idx].count ?? 0;
        frm.setFieldValue(["extraData", idx.toString(), "totalAmount"], relatedAmount * relatedCount);
        setSum(extraData?.reduce((acc: number, f: any) => acc + (f?.amount ?? 0) * (f?.count ?? 0), 0) ?? 0);
    }
    return <div id='with-factor-payment-link'
        className="center"
        style={{
            width: "100%",
            borderRight: "solid 1px #eee",
            borderBottom: "solid 1px #eee",
            borderLeft: "solid 1px #eee",
            padding: "1rem"
        }}>
        {!link ?
            <Form
                name="simple-frm"
                form={frm}
                onFinish={onConfirm}
                autoComplete="off"
                layout="vertical"
                style={{ maxWidth: 800 }}
                initialValues={{wageSide:WageSide.merchant}}
            >
                <Row gutter={[20, 20]}>
                    <Col xs={24} sm={8}>
                        <Form.Item
                            name="payerName"
                            label={`${t("name")} ${t("payer")}`}
                            rules={[{ required: true, message: t("required") ?? "" }]}>
                            <Input placeholder={t("payer") ?? ""} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={8}>
                        <Form.Item
                            name="payerMobileNumber"
                            label={`${t("mobileNumber")} ${t("payer")}`}
                            rules={[
                                {
                                    pattern: patterns.mobile,
                                    message: t("wrongFormat") ?? ""
                                },
                                // ({ getFieldValue }) => ({
                                //     validator(_, value) {
                                //         const email = getFieldValue('payerEmail');
                                //         if (!value && !email) {
                                //             return Promise.reject(new Error(t("mobileOrEmailIsRequired") ?? ""));
                                //         }
                                //         return Promise.resolve();
                                //     },
                                // })
                            ]}
                        >
                            <Input placeholder={t("mobileNumber") ?? ""} className="ltr-elm  placeholder-r" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={8}>
                        <Form.Item
                            name="payerNationalCode"
                            label={`${t("nationalCode")} ${t("payer")}`}
                            rules={[
                                {
                                    pattern: patterns.nationalCode,
                                    message: t("wrongFormat") ?? ""
                                }
                            ]}>
                            <Input placeholder={t("nationalCode") ?? ""} className="ltr-elm  placeholder-r" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={8}>
                        <Form.Item
                            name="payerEmail"
                            label={`${t("email")} ${t("payer")}`}
                            rules={[
                                {
                                    pattern: patterns.email,
                                    message: t("wrongFormat") ?? ""
                                }
                            ]}>
                            <Input placeholder={t("email") ?? ""} className="ltr-elm  placeholder-r" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={8}>
                        <Form.Item name="wageSide" label={t("wageSide")} rules={[
                            {
                                required: true,
                                message: t("required") ?? "",
                            }
                        ]}>
                            <Select
                                showSearch
                                placeholder={t("wageSide")}
                                options={util.convrtEnumToOptions(WageSide)}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24}>
                        <Form.Item
                            name="description"
                            label={t("description")}
                            rules={[
                                {
                                    required: true,
                                    message: t("required") ?? "",
                                }
                            ]}>
                            <Input.TextArea placeholder={t("description") ?? ""} className="" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24}>
                        <Form.List
                            name="extraData"
                            rules={[
                                {
                                    validator: async (_, extraData) => {
                                        console.log("req", extraData)
                                        if (!extraData || extraData.length < 1) {
                                            return Promise.reject(new Error(t("atleastXItemIsRequired", { x: 1 }) ?? ""));
                                        }
                                    },
                                },
                            ]}>
                            {(fields, { add, remove }, { errors }) => (
                                <>
                                    {fields.map(({ key, name, ...restField }, idx) => (
                                        <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                                            <Form.Item
                                                {...restField}
                                                label={idx === 0 ? t("itemName") : undefined}
                                                name={[name, 'name']}
                                                rules={[{ required: true, message: t("required") ?? "" }]}
                                            >
                                                <Input placeholder={t("itemName") ?? ""} />
                                            </Form.Item>
                                            <Form.Item
                                                {...restField}
                                                label={idx === 0 ? `${t("amountPerUnit")}(${t("baseCurrency")})` : undefined}
                                                name={[name, 'amount']}
                                                rules={[{ required: true, message: t("required") ?? "" }]}
                                            >
                                                <InputNumber
                                                    onChange={(e) => calcTotalAmount(idx)}
                                                    onBlur={(e) => calcTotalAmount(idx)}
                                                    stringMode={false}
                                                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
                                                    placeholder={t("amountPerUnit") ?? ""}
                                                    className="ltr-elm placeholder-r w-100"
                                                    controls={false}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                {...restField}
                                                label={idx === 0 ? t("count") : undefined}
                                                name={[name, 'count']}
                                                rules={[{ required: true, message: t("required") ?? "" }]}
                                            >
                                                <InputNumber
                                                    onChange={(e) => calcTotalAmount(idx)}
                                                    onBlur={(e) => calcTotalAmount(idx)}
                                                    placeholder={t("count") ?? ""}
                                                    className="ltr-elm placeholder-r w-100"
                                                    controls={false}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                {...restField}
                                                label={idx === 0 ? `${t("totalAmount")}(${t("baseCurrency")})` : undefined}
                                                name={[name, 'totalAmount']}
                                                rules={[{ required: true, message: t("required") ?? "" }]}
                                            >
                                                <InputNumber
                                                    readOnly
                                                    disabled
                                                    //value={(rowsSum?.[idx.toString()]) ?? 0}
                                                    onChange={(e) => calcTotalAmount(idx)}
                                                    onBlur={(e) => calcTotalAmount(idx)}
                                                    placeholder={t("totalAmount") ?? ""}
                                                    className="ltr-elm placeholder-r w-100"
                                                    stringMode={false}
                                                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    controls={false}
                                                />
                                            </Form.Item>
                                            <Button
                                                type="link"
                                                block
                                                style={{ marginTop: idx === 0 ? 30 : 0 }}
                                                icon={<CustomIcon name="IoCloseCircleOutline" />} onClick={() => {
                                                    remove(name);
                                                    calcTotalAmount(idx);
                                                }} />

                                        </Space>
                                    ))}
                                    <Form.Item>
                                        <Button type="dashed" onClick={() => add()} block icon={<CustomIcon name="IoAddOutline" size={20} />}>
                                            {t("addNewFactorItem")} ({util.commaThousondSeperator(sum)} {sum>0?t("baseCurrency"):""})
                                        </Button>
                                        <Form.ErrorList errors={errors} />
                                    </Form.Item>
                                </>
                            )}

                        </Form.List>
                    </Col>
                    <Col xs={24} sm={24}>
                        <Form.Item className="flex-row-end btns" >
                            <Button type="primary" htmlType="submit" loading={creating}>
                                {t("createLink")}
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
            : <LinkForShare
                link={link}
                name={name}
                onBack={() => {
                    setName("");
                    setLink("");
                }}
            />
        }
    </div>;
}
export default WithFactor;